module.exports = {"breadcrumb":{"ja":"個人情報保護方針","en":"Privacy Policy"},"title":{"ja":"一般財団法人東京マラソン財団個人情報保護方針","en":"Privacy Policy"},"japan":{"ja":"日本国内所在者および非EEA所在者","en":"For applicants based in the European Economic Area (EEA)"},"eea":{"ja":"EEA所在者","en":"For applicants based outside the EEA"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/privacy/privacy.json
// module id = K294
// module chunks = 1